export default "__VITE_ASSET__13b16f34__"